import { useState } from 'react';
import { Link } from 'react-router-dom';
import { displaySrc, formatPrice, type ArtworkPiece } from '../lib/artwork';
import { ImageLightbox } from './ImageLightbox';

export function ArtworkGrid({
  pieces,
  emptyHint,
}: {
  pieces: ArtworkPiece[];
  emptyHint?: string;
}) {
  const [lightbox, setLightbox] = useState<{ src: string; alt: string; title: string } | null>(
    null,
  );

  if (pieces.length === 0) {
    return (
      <div className="empty-state">
        {emptyHint ?? 'No pieces here yet — add them in Studio or drop files into public/artwork.'}
      </div>
    );
  }

  return (
    <>
      <div className="grid-art">
        {pieces.map((piece) => {
          const full = displaySrc(piece, 'full');
          const thumb = displaySrc(piece, 'thumb');
          return (
            <article key={piece.id} className="card-art">
              <button
                type="button"
                className="thumb thumb-button"
                onClick={() =>
                  setLightbox({
                    src: full,
                    alt: piece.title,
                    title: piece.title,
                  })
                }
                aria-label={`View larger: ${piece.title}`}
              >
                <img
                  src={thumb}
                  alt={piece.title}
                  loading="lazy"
                  decoding="async"
                  width={720}
                  height={540}
                />
              </button>
              <div className="meta">
                {piece.forSale && !piece.sold ? <span className="badge badge-sale">For sale</span> : null}
                {piece.sold ? <span className="badge">Sold</span> : null}
                <h3>{piece.title}</h3>
                {piece.medium ? <p className="sub">{piece.medium}</p> : null}
                {piece.description ? <p className="sub">{piece.description}</p> : null}
                {piece.forSale && piece.price != null && !piece.sold ? (
                  <div className="price-tag">{formatPrice(piece.price)}</div>
                ) : null}
                {piece.forSale && !piece.sold ? (
                  <div style={{ marginTop: '0.75rem' }}>
                    <Link
                      className="btn btn-ghost"
                      to={`/contact?subject=original&piece=${encodeURIComponent(piece.title)}`}
                    >
                      Inquire
                    </Link>
                  </div>
                ) : null}
              </div>
            </article>
          );
        })}
      </div>
      <ImageLightbox
        open={!!lightbox}
        src={lightbox?.src ?? ''}
        alt={lightbox?.alt ?? ''}
        title={lightbox?.title}
        onClose={() => setLightbox(null)}
      />
    </>
  );
}
